import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numbersOnly]'
})
export class NumbersOnlyDirective implements OnInit {
  @Input() numbersOnly: boolean = true;
  
  private allowedKeys = [
    'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete',
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4',
    'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9'
  ];

  constructor(
    private el: ElementRef,
    private control: NgControl
  ) { }

  ngOnInit() {
    // Initial cleanup in case value was set programmatically
    console.log('here')
    if (this.numbersOnly) {
      this.cleanValue();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    console.log('here')
    if (!this.numbersOnly) return;

    // Allow Ctrl+A/C/V/X
    if (['a', 'c', 'v', 'x'].includes(event.key) && (event.ctrlKey || event.metaKey)) {
      return;
    }

    // Check if key is allowed
    if (!this.allowedKeys.includes(event.key) && !this.allowedKeys.includes(event.code)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.numbersOnly) return;
    
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text/plain');
    if (pastedText) {
      const numbersOnly = pastedText.replace(/[^0-9]/g, '');
      this.updateValue(numbersOnly);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (!this.numbersOnly) return;
    
    const input = event.target as HTMLInputElement;
    const newValue = input.value.replace(/[^0-9]/g, '');
    if (input.value !== newValue) {
      this.updateValue(newValue);
    }
  }

  @HostListener('blur')
  onBlur() {
    if (!this.numbersOnly) return;
    this.cleanValue();
  }

  private cleanValue() {
    const currentValue = this.el.nativeElement.value;
    const cleanValue = currentValue.replace(/[^0-9]/g, '');
    this.updateValue(cleanValue);
  }

  private updateValue(value: string) {
    if (this.control?.control) {
      this.control.control.setValue(value, { emitEvent: false });
      // Manually trigger value update in the DOM
      this.el.nativeElement.value = value;
      this.el.nativeElement.dispatchEvent(new Event('input'));
    } else {
      this.el.nativeElement.value = value;
    }
  }
}